/* WyldCam: the microSD cards added by the "Cover more ground" bundle follow the camera quantity in the cart.
   Kaching deals: camera line  properties.__kaching_bundles = {deal, main:true, id, bid}
                  microSD line properties.__kaching_bundles = {id, deal, upsell}   (same id)
   Native deals:  camera line  properties._wcb = id
                  microSD line properties._wcb = 'sd:' + id + ':' + (free|addon)
   Rule: camera qty >= 2 -> cards = camera qty, free tier (Kaching upsell HKEW for 2, gqMD for 3+);
         camera qty 1 -> free cards removed (a ticked £5-off card, upsell UrDk / addon, is kept);
         camera removed -> its free cards removed. */
(function () {
  if (window.wcSdSync) return;
  var UPSELL = { 1: 'UrDk', 2: 'HKEW', 3: 'gqMD' };
  var SD_DEFAULT = 61970977161546;
  var SD_BY_CAMERA = { '4k-trail-camera-with-4g-screen': 61970977227082 };
  var busy = false, again = false, timer = null;
  /* R76: one request per cart change. The last full cart is cached from cart responses; a quantity change or a
     removal in the drawer is sent together with the matching microSD update (/cart/update.js), so the drawer
     re-renders once instead of twice. */
  var lastCart = null, cacheOk = false;
  function setCart(c) { if (c && c.items && typeof c.item_count === 'number' && c.token) { lastCart = c; cacheOk = true; } }
  var JH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var nf = window.fetch;
  if (nf) window.fetch = function (u, o) {
    var url = typeof u === 'string' ? u : (u && u.url) || '';
    var method = ((o && o.method) || 'GET').toUpperCase();
    try {
      if (method === 'POST' && /\/cart\/change(\.js)?(\?|$)/.test(url) && o && typeof o.body === 'string' && cacheOk && lastCart) {
        var b = json(o.body);
        if (b && b.line != null && b.quantity != null && b.id == null) {
          var idx = parseInt(b.line, 10) - 1, q = parseInt(b.quantity, 10);
          var it = lastCart.items[idx];
          if (it && q >= 0) {
            var sim = { items: [] };
            lastCart.items.forEach(function (x, i) { if (i === idx) { if (q > 0) sim.items.push(Object.assign({}, x, { quantity: q })); } else sim.items.push(x); });
            var todo = plan(sim);
            if (Object.keys(todo.updates).length || todo.adds.length) {
              var upd = {}; upd[it.key] = q;
              Object.keys(todo.updates).forEach(function (k) { if (k !== it.key) upd[k] = todo.updates[k]; });
              cacheOk = false;
              if (!todo.adds.length) {
                return nf.call(window, '/cart/update.js', { method: 'POST', headers: JH, body: JSON.stringify({ updates: upd, sections: b.sections, sections_url: b.sections_url }) })
                  .then(function (r) { r.clone().json().then(setCart).catch(function () {}); return r; });
              }
              busy = true; var d1 = false; /* R85: no second sync while this change is in flight */
              return nf.call(window, '/cart/update.js', { method: 'POST', headers: JH, body: JSON.stringify({ updates: upd }) })
                .then(function (r) { return r.json(); })
                .then(function (c1) {
                  if (!c1 || c1.status) throw c1;
                  d1 = true;
                  return nf.call(window, '/cart/add.js', { method: 'POST', headers: JH, body: JSON.stringify({ items: todo.adds, sections: b.sections, sections_url: b.sections_url }) })
                    .then(function (r) { return r.json(); })
                    .then(function (a) {
                      if (!a || a.status || !a.sections) throw a;
                      var count = c1.item_count + todo.adds.reduce(function (s, x) { return s + x.quantity; }, 0);
                      return new Response(JSON.stringify({ item_count: count, sections: a.sections }), { status: 200, headers: { 'Content-Type': 'application/json' } });
                    });
                })
                .catch(function () {
                  /* R85: if the camera quantity was already changed, never resend the original change (it would add the cards twice) */
                  if (!d1) return nf.call(window, u, o);
                  return nf.call(window, '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                    return nf.call(window, '/?sections=' + encodeURIComponent([].concat(b.sections || []).join(','))).then(function (r) { return r.json(); }).then(function (s) {
                      return new Response(JSON.stringify({ item_count: c.item_count, sections: s }), { status: 200, headers: { 'Content-Type': 'application/json' } });
                    });
                  });
                })
                .finally(function () { busy = false; schedule(400); });
            }
          }
        }
      }
    } catch (e) {}
    var p = nf.apply(this, arguments);
    if (/\/cart\.js(\?|$)|\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) p.then(function (r) { r.clone().json().then(setCart).catch(function () {}); }).catch(function () {});
    else if (/\/cart\/(add|clear)/.test(url)) cacheOk = false;
    return p;
  };

  function json(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function upsellFor(q) { return UPSELL[Math.min(Math.max(q, 1), 3)]; }

  /* Returns { updates: {key: qty}, adds: [items] } needed to bring the cart in line */
  function plan(cart) {
    var groups = {}, updates = {}, adds = [];
    function g(id) { return groups[id] || (groups[id] = { cams: [], sds: [] }); }
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      var k = p.__kaching_bundles ? json(p.__kaching_bundles) : null;
      if (k && k.id) {
        if (k.main) g('k:' + k.id).cams.push({ it: it, deal: k.deal, id: k.id, mode: 'k' });
        else if (k.upsell) g('k:' + k.id).sds.push({ it: it, free: k.upsell !== UPSELL[1], upsell: k.upsell });
        return;
      }
      if (typeof p._wcb === 'string' && p._wcb) {
        var m = p._wcb.split(':');
        if (m[0] === 'sd' && m[1]) g('n:' + m[1]).sds.push({ it: it, free: m[2] === 'free', upsell: m[2] });
        else g('n:' + p._wcb).cams.push({ it: it, id: p._wcb, mode: 'n' });
      }
    });
    Object.keys(groups).forEach(function (key) {
      var grp = groups[key];
      var camQ = grp.cams.reduce(function (s, c) { return s + c.it.quantity; }, 0);
      var cam = grp.cams[0];
      if (camQ >= 2 && cam) {
        var want = cam.mode === 'k' ? upsellFor(camQ) : 'free';
        /* R90: Kaching gives at most 3 free cards, so never add a 4th card that would be charged */
        var sdQ = cam.mode === 'k' ? Math.min(camQ, 3) : camQ;
        var keep = null;
        grp.sds.forEach(function (s) {
          if (!keep && s.upsell === want) { keep = s; if (s.it.quantity !== sdQ) updates[s.it.key] = sdQ; }
          else updates[s.it.key] = 0;
        });
        if (!keep) {
          var variant = grp.sds[0] ? grp.sds[0].it.variant_id : (SD_BY_CAMERA[cam.it.handle] || SD_DEFAULT);
          var props = cam.mode === 'k'
            ? { __kaching_bundles: JSON.stringify({ id: cam.id, deal: cam.deal, upsell: want }) }
            : { _wcb: 'sd:' + cam.id + ':free' };
          adds.push({ id: variant, quantity: sdQ, properties: props });
        }
      } else {
        /* one camera (or none left): drop the free cards, keep a ticked add-on card only while the camera is there */
        grp.sds.forEach(function (s) {
          if (s.free || camQ === 0) updates[s.it.key] = 0;
          else if (s.it.quantity > camQ) updates[s.it.key] = camQ;
        });
      }
    });
    return { updates: updates, adds: adds };
  }

  function sectionIds() {
    var d = document.querySelector('cart-drawer');
    return d && d.dataset.sectionId ? d.dataset.sectionId : null;
  }

  function refresh(data) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var sid = sectionIds();
    var after = function (res) {
      if (window.wcRenderDrawer) window.wcRenderDrawer(res);
      document.dispatchEvent(new CustomEvent('wc:sd-synced', { detail: res }));
    };
    if (data && data.sections && sid && data.sections[sid]) { after(data); return; }
    if (!sid) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      return fetch('/?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); }).then(function (sections) {
        after({ sections: sections, item_count: cart.item_count });
      });
    }).catch(function () {});
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    var sid = sectionIds();
    /* R85: always read the live cart here (a cached cart could be older than a change still in flight and add the cards twice) */
    var got = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    got.then(function (cart) {
      var todo = plan(cart);
      var hasUpd = Object.keys(todo.updates).length > 0;
      if (!hasUpd && !todo.adds.length) return null;
      var chain = Promise.resolve(null);
      if (hasUpd) chain = chain.then(function () { return post('/cart/update.js', { updates: todo.updates, sections: todo.adds.length ? undefined : sid || undefined }); });
      if (todo.adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: todo.adds, sections: sid || undefined }); })
        .then(function (res) {
          if (!res || res.status || !res.sections) return res;
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { res.item_count = c.item_count; return res; });
        });
      return chain.then(function (res) { refresh(res); return true; });
    }).catch(function (e) { console.error('wc-sd-sync', e); }).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule(ms) { clearTimeout(timer); timer = setTimeout(run, ms == null ? 150 : ms); }

  window.wcSdSync = { run: run, plan: plan };
  document.addEventListener('cart:updated', function () { schedule(); });
  if (/\/cart\/?$/.test(location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(0); }); else schedule(0);
  }
})();

/* R49 – Native bundles (new cameras): show the bundle the way it was sold, in the cart drawer and on /cart.
   The native "Buy 2 / Buy 3" discount sits on the camera line and already covers the value of the free cards,
   so Shopify shows the cards at full price and the camera at an odd price. Here the free cards read "Free"
   and the camera line shows the bundle total. Display only: the cart total is unchanged. */
(function () {
  if (window.wcBundleView) return;
  window.wcBundleView = true;

  var css = document.createElement('style');
  css.textContent =
    '.cart-drawer__item-discount{min-width:0!important;max-width:100%}' +
    '.cart-drawer__item-discount span{max-width:none!important;white-space:normal!important;overflow:visible!important}' +
    '.cart-drawer__item-content{min-width:0}' +
    '.wcbv-price{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px;line-height:1.3}' +
    '.wcbv-price b{font-weight:600;color:#C2541F}' +
    '.wcbv-price s{opacity:.6}' +
    '.wcbv-note{flex-basis:100%;font-size:12px;opacity:.8}' +
    '.wcbv-free .cart-drawer__item-actions{visibility:hidden}';
  document.head.appendChild(css);

  function money(c) {
    var v = (c / 100).toFixed(2).split('.');
    return '£' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1];
  }

  var cart = null, pending = null;

  function load() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; pending = null; paint(); return c; })
      .catch(function () { pending = null; });
    return pending;
  }

  function groupsOf(c) {
    var groups = {};
    c.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (typeof p._wcb !== 'string' || !p._wcb) return;
      var m = p._wcb.split(':');
      var id = m[0] === 'sd' ? m[1] : p._wcb;
      var g = groups[id] || (groups[id] = { cams: [], sds: [] });
      if (m[0] === 'sd') { if (m[2] === 'free') g.sds.push({ it: it, i: i }); }
      else g.cams.push({ it: it, i: i });
    });
    return groups;
  }

  function rowsFor(index) {
    return document.querySelectorAll('cart-drawer-item[data-index="' + (index + 1) + '"]');
  }

  function setPrice(row, html) {
    var box = row.querySelector('.cart-drawer__item-price');
    if (!box) return;
    var disc = box.querySelector('.cart-drawer__item-discounts');
    Array.prototype.slice.call(box.children).forEach(function (ch) {
      if (ch !== disc && !ch.classList.contains('wcbv-price')) ch.style.display = 'none';
    });
    var mine = box.querySelector('.wcbv-price');
    if (!mine) { mine = document.createElement('div'); mine.className = 'wcbv-price'; box.insertBefore(mine, box.firstChild); }
    if (mine.innerHTML !== html) mine.innerHTML = html;
    /* text added by other scripts next to the price (e.g. "(Save £x)") */
    Array.prototype.slice.call(row.querySelectorAll('.cart-drawer__item-prices > :not(.cart-drawer__item-price)')).forEach(function (el) { el.style.display = 'none'; });
  }

  function paint() {
    if (!cart || !cart.items) return;
    var rows = document.querySelectorAll('cart-drawer-item[data-index]');
    if (!rows.length) return;
    var groups = groupsOf(cart);
    Object.keys(groups).forEach(function (id) {
      var g = groups[id];
      if (!g.cams.length || !g.sds.length) return;
      var camQ = g.cams.reduce(function (s, c) { return s + c.it.quantity; }, 0);
      if (camQ < 2) return;
      var sdQ = g.sds.reduce(function (s, x) { return s + x.it.quantity; }, 0);
      var sdPaid = g.sds.reduce(function (s, x) { return s + x.it.final_line_price; }, 0);
      var sdFull = g.sds.reduce(function (s, x) { return s + x.it.original_line_price; }, 0);
      var camPaid = g.cams.reduce(function (s, c) { return s + c.it.final_line_price; }, 0);
      var camFull = g.cams.reduce(function (s, c) {
        var unit = Math.max(c.it.original_price, (c.it.variant && c.it.variant.compare_at_price) || 0);
        return s + unit * c.it.quantity;
      }, 0);
      var total = camPaid + sdPaid;
      var note = camQ + ' cameras + ' + sdQ + ' free microSD card' + (sdQ > 1 ? 's' : '');
      g.cams.forEach(function (c, k) {
        Array.prototype.forEach.call(rowsFor(c.i), function (row) {
          if (k > 0) { setPrice(row, '<span class="wcbv-note">Part of the bundle above</span>'); return; }
          setPrice(row, '<b>' + money(total) + '</b>' + (camFull > total ? '<s>' + money(camFull) + '</s>' : '') + '<span class="wcbv-note">' + note + '</span>');
        });
      });
      g.sds.forEach(function (x) {
        Array.prototype.forEach.call(rowsFor(x.i), function (row) {
          row.classList.add('wcbv-free');
          setPrice(row, '<b>Free</b><s>' + money(x.it.original_line_price) + '</s><span class="wcbv-note">Included with your ' + camQ + ' cameras</span>');
          var d = row.querySelector('.cart-drawer__item-discounts');
          if (d) d.style.display = 'none';
        });
      });
    });
  }

  /* Re-paint whenever the cart markup is replaced */
  var raf = 0;
  var mo = new MutationObserver(function (list) {
    for (var n = 0; n < list.length; n++) {
      var t = list[n].target;
      if (t.closest && (t.closest('cart-drawer') || t.closest('.cart-drawer__items') || t.querySelector && t.querySelector('cart-drawer-item'))) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { paint(); });
        return;
      }
    }
  });
  function start() {
    mo.observe(document.body, { childList: true, subtree: true });
    load();
  }
  ['wc:sd-synced', 'cart:refresh', 'cart-drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { load(); });
  });
  /* Any cart change through fetch also refreshes the view */
  var of = window.fetch;
  if (of) {
    window.fetch = function (u) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        /* R76: read the cart straight from the response when it is a full cart; otherwise fetch it once */
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function (r) { return r.clone().json(); })
          .then(function (d) { if (d && d.items && d.token) { cart = d; paint(); } else load(); })
          .catch(function () { load(); });
      } catch (e) {}
      return p;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
